import { LinkAction } from '@leverege/molten/routes';
import { Config } from '@leverege/plugin';
export default ({
  id,
  relationship
}) => LinkAction.create({
  id,
  layout: Config.get(id, 'layout', {
    sort: relationship.blueprint.getTagStartingWith('navSortOverview:', true) || 'aaa',
    sectionName: relationship.blueprint.getString('overviewSectionName')
  }),
  matches: {
    use: 'navBar',
    client: 'ItemScreen',
    path: relationship.path
  },
  handles: cxt => {
    // const aPersona = UI.get( GlobalState.get() ).activePersona?.name
    // if ( shouldExclude( aPersona, attribute, excludeFrom, attrExcludeFrom ) ) {
    //   return false
    // }
    return true;
  },
  name: relationship.blueprint.getString('overview'),
  icon: relationship.getIcon('navIcon'),
  path: `/${relationship.urlPath}/info`
});